<div [formGroup]="formGroup()"
     class="border-form-control primary-bg-100 rounded position-relative">                     
    <label [for]="id()"
           [id]="id() + '-label'"
           class="position-absolute primary-bg-150 primary-text-200 px-1 font-4 form-label">{{label()}}<span *ngIf="required()" class="text-red-500"> *</span></label>

    <select [formControlName]="id()"
            class="p-3 bg-transparent border-0 primary-text w-100">

        <option class="text-black"
                disabled
                value=""
                selected>Select project</option>               

        @for(project of projects(); track project)
        {
            <option [value]="project.id"
                    class="text-black">
                <project-item [project]="project" />
            </option>
        }
        @empty
        {
            <option class="text-black"
                    value=""
                    disabled
                    selected>No project available</option>
        }
    </select>
</div>